const AWARD = "award";
const MERIT_BADGE = "meritBadge";
const RANK = "rank";
const ADVENTURE = "adventure";
const ELECTIVE = "elective";

const types = {
  AWARD,
  MERIT_BADGE,
  RANK,
  ADVENTURE,
  ELECTIVE,
};

const advancementTypes = types;

const RETIRED = "RETIRED";
const DISABLED = "DISABLED";
const NOT_STARTED = "NOT_STARTED";
const STARTED = "STARTED";
const IN_PROGRESS = "IN_PROGRESS";
const COMPLETED = "COMPLETED";
const EARNED = "EARNED";
const APPROVED = "APPROVED";
const LEADER_SIGNED = "LEADER_SIGNED";
const LEADER_APPROVED = "LEADER_APPROVED";
const COUNSELOR_APPROVED = "COUNSELOR_APPROVED";
const AWARDED = "AWARDED";

const INITIAL_STATUS = NOT_STARTED;
const UNKNOWN_STATUS = "UNKNOWN_STATUS";

const statusValues = {
  DISABLED: 0,
  NOT_STARTED: 10,
  RETIRED: 20,
  STARTED: 30,
  IN_PROGRESS: 40,
  LEADER_SIGNED: 45,
  COMPLETED: 50,
  EARNED: 60,
  APPROVED: 70,
  LEADER_APPROVED: 80,
  COUNSELOR_APPROVED: 90,
  AWARDED: 100,
};

// for any parsing/transformation from api
// map here the status value from api to the status for UI
// key is the value from api
// value is the status used in UI
const statusMapParser = {
  disabled: DISABLED,
  retired: RETIRED,
  started: STARTED,
  completed: COMPLETED,
  earned: EARNED,
  approved: APPROVED,
  awarded: AWARDED,
  notstarted: NOT_STARTED,
  not_started: NOT_STARTED,
  "not started": NOT_STARTED,
  "": INITIAL_STATUS,
  null: INITIAL_STATUS,
  undefined: INITIAL_STATUS,
  leadersigned: LEADER_SIGNED,
  leader_signed: LEADER_SIGNED,
  "leader signed": LEADER_SIGNED,
  leaderapproved: LEADER_APPROVED,
  leader_approved: LEADER_APPROVED,
  "leader approved": LEADER_APPROVED,
  counselorapproved: COUNSELOR_APPROVED,
  counselor_approved: COUNSELOR_APPROVED,
  "counselor approved": COUNSELOR_APPROVED,

  // assign itself, when repeated parseStatus is called
  [RETIRED]: RETIRED,
  [DISABLED]: DISABLED,
  [NOT_STARTED]: NOT_STARTED,
  [STARTED]: STARTED,
  [IN_PROGRESS]: IN_PROGRESS,
  [COMPLETED]: COMPLETED,
  [EARNED]: EARNED,
  [APPROVED]: APPROVED,
  [LEADER_SIGNED]: LEADER_SIGNED,
  [LEADER_APPROVED]: LEADER_APPROVED,
  [COUNSELOR_APPROVED]: COUNSELOR_APPROVED,
  [AWARDED]: AWARDED,
};

const RETIRED_AWARDS = [111, 112, 147];

const advancementImageURLPrefix =
  "https://d3hdyt7ugiz6do.cloudfront.net/images/";

export {
  types,
  advancementTypes,
  advancementImageURLPrefix,
  statusValues,
  statusMapParser,
  RETIRED,
  DISABLED,
  NOT_STARTED,
  STARTED,
  IN_PROGRESS,
  COMPLETED,
  EARNED,
  APPROVED,
  LEADER_SIGNED,
  LEADER_APPROVED,
  COUNSELOR_APPROVED,
  AWARDED,
  INITIAL_STATUS,
  UNKNOWN_STATUS,
  RETIRED_AWARDS,
};
